import React from 'react';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import './CtaBanner.css';

export default function CtaBanner() {
  const navigate = useNavigate();

  return (
    <section className="cta-banner">
      <div className="cta-banner__container">
        <h2 className="cta-banner__heading">
          See how Magnetix works for your team.
        </h2>
        <p className="cta-banner__sub">
          Book a 20-minute demo — no sales pitch, just a walkthrough built around
          your team&apos;s learning and performance goals.
        </p>
        <button
          className="cta-banner__btn"
          onClick={() => navigate('/contact')}
        >
          Book a Demo
          <ArrowRight />
        </button>
      </div>
    </section>
  );
}
